import React, { useEffect } from 'react';
import './ScanNotification.css';
import { DSIcon } from '../design-system/primitives';

/**
 * ScanNotification component
 * Displays a modal notification for QR scan results with vibration feedback
 */
function ScanNotification({ notification, onDismiss }) {
  useEffect(() => {
    if (!notification) return;

    // Trigger vibration for tactile feedback
    if ('vibrate' in navigator) {
      if (notification.success) {
        // Short vibration for success
        navigator.vibrate(200);
      } else {
        // Two short vibrations for error
        navigator.vibrate([100, 50, 100]);
      }
    }

    // Auto-dismiss after 5 seconds
    const timer = setTimeout(() => {
      onDismiss();
    }, 5000);

    return () => clearTimeout(timer);
  }, [notification, onDismiss]);

  if (!notification) return null;

  const isSuccess = notification.success;

  return (
    <div className="scan-notification-overlay" onClick={onDismiss}>
      <div 
        className={`scan-notification-modal ${isSuccess ? 'success' : 'error'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="scan-notification-icon">
          {isSuccess ? <DSIcon name="check" /> : <DSIcon name="x" />}
        </div>
        <div className="scan-notification-content">
          <h2 className="scan-notification-title">
            {notification.message}
          </h2>
          {notification.deviceName && (
            <p className="scan-notification-device">
              {notification.deviceName}
            </p>
          )}
          {isSuccess && notification.newBalance !== undefined && (
            <p className="scan-notification-balance">
              Remaining balance: ${notification.newBalance.toFixed(2)}
            </p>
          )}
          {!isSuccess && notification.currentBalance !== undefined && (
            <p className="scan-notification-balance">
              Current balance: ${notification.currentBalance.toFixed(2)}
              {notification.required && ` (Required: $${notification.required.toFixed(2)})`}
            </p>
          )}
        </div>
        <button 
          className="scan-notification-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss notification"
        >
          ×
        </button>
        <div className="scan-notification-progress" />
      </div>
    </div>
  );
}

export default ScanNotification;
